import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table13bData = { [key: string]: Table13bRow };

export interface ITable13bProps {
  data: Table13bData;
}

interface ITable13bState {
}

export interface Table13bRow {
  fatal: number;
  injuryA: number;
  injuryB: number;
  injuryC: number;
  pdo: number;
  total: number;
}

const sortOrder = [
  "Veh < 10k with Haz/Mat",
  "Bus/Large Van",
  "Single Unit Truck > 10k",
  "Truck Pulling Trailer",
  "Semi Trailer Truck",
  "Unknown",
  "TOTALS",
];

export default class Table13b extends React.Component<ITable13bProps, ITable13bState> {
  constructor(props: ITable13bProps) {
    super(props);
  }

  componentDidMount = function () {
  }

  public render() {
    return (
      this.props.data ?
        <table className="ss-table summaryTable1">
          <colgroup>
            <col style={{ width: '50%' }} />
            <col span={6} style={{ width: '8.3%' }} />
          </colgroup>
          <thead>
            <tr>
              <th rowSpan={2} className="border-right-bold">
                <div className="ss-table-header">
                  <span className="header-number" style={{ border: 'none' }}>13b</span>
                  <div style={{ width: '3px', height: '64px', backgroundColor: 'black' }} />
                  <span className="header-text">HEAVY VEHICLE BODY STYLE OF CRASH VEHICLES</span>
                </div>
              </th>
              <th rowSpan={2}>TOTAL</th>
              <th rowSpan={2}>FATAL</th>
              <th colSpan={3}>INJURY</th>
              <th rowSpan={2}>PDO **</th>
            </tr>
            <tr>
              <th>A*</th>
              <th>B*</th>
              <th>C*</th>
            </tr>
          </thead>
          <tbody>
            {sortBasedOnList(this.props.data, sortOrder).map((key) =>
              <tr key={key} className={key === "TOTALS" ? "border-bold bold-text" : null}>
                <td className="border-right-bold">{key}</td>
                <td className="numberTotals">{this.props.data[key].total}</td>
                <td className="numberTotals">{this.props.data[key].fatal}</td>
                <td className="numberTotals">{this.props.data[key].injuryA}</td>
                <td className="numberTotals">{this.props.data[key].injuryB}</td>
                <td className="numberTotals">{this.props.data[key].injuryC}</td>
                <td className="numberTotals">{this.props.data[key].pdo}</td>
              </tr>
            )}
          </tbody>
        </table>
        : <p>Loading...</p>
    );
  }
}
